/// <reference path="../../ng-services/chat.service.ts"/>

import { ChatConversationMessage, GenericChatMessage } from '../../models/chat';
import { ChatConversationService } from '../../ng-services/chat-conversation.service';
import { ChatMessageSenderService } from '../../ng-services/chat-message-sender.service';
import { AuthServiceInterface } from '../../ng-services/AuthServiceInterface';

(function () {
    class ChatMessageComponent {
        static $inject = ['ChatMessageSenderService', 'ChatConversationService', 'AuthService'];

        public message!: GenericChatMessage;
        public searchTerm!: string;
        public isPublicChat!: boolean;

        get place() {
            return this.message.place;
        }

        get isEditable() {
            const { message } = this;
            // message needs to be received from server
            // we need server-side ID
            if (message.id === message.guid) {
                return false;
            }

            return message?.owner?.id === this.authService.getUserId();
        }

        constructor(
            private chatMessageSender: ChatMessageSenderService,
            private chatConversationService: ChatConversationService,
            private authService: AuthServiceInterface
        ) {}

        public resend() {
            this.chatMessageSender.resend(this.message as ChatConversationMessage);
        }

        public cancel() {
            this.chatMessageSender.cancel(this.message as ChatConversationMessage);
        }

        get attachmentsDisplayMode(): string {
            // @ts-ignore
            const allImages = (this.message as ChatConversationMessage)?.attachments.every((attachment) =>
                attachment?.file_mimetype?.startsWith('image/')
            );

            if (allImages) {
                return 'gallery';
            }

            return 'default';
        }

        get image() {
            return this.message.owner.picture_url;
        }

        get elementId() {
            return `chat-message-${this.message.id}`;
        }

        get quotedMessage() {
            return this.message.quoted_message;
        }

        get hasAttachments() {
            // @ts-ignore
            return this.message.attachments?.length > 0;
        }

        onClick(buttonName: 'edit' | 'quote') {
            console.log('Clicked', buttonName, ...arguments);

            if (buttonName === 'quote') {
                this.chatConversationService.quotedMessage$.onNext(this.message as ChatConversationMessage);
            }

            if (buttonName === 'edit') {
                this.chatConversationService.editMessage$.onNext(this.message as ChatConversationMessage);
            }
        }

        get isMessage() {
            return this.message.type === 'message';
        }

        get isCallEvent() {
            return this.message.type === 'call_event';
        }

        get isDisplayable() {
            return this.isMessage || (this.isCallEvent && (this.message.content as any).event_type !== 'started');
        }

        get ownerProfileUrl() {
            return `/${this.message.owner.id}`;
        }
    }

    angular.module('tradersyard').component('tyChatMessage', {
        // language=HTML
        template: `
    <div class="chat_message" ng-class="{'is-first': $ctrl.first}" id="{{$ctrl.elementId}}" ng-if="$ctrl.isDisplayable">

        <div class="chat_message__toolbar" ng-if="!$ctrl.isPublicChat && $ctrl.isMessage">
            <ty-chat-message-toolbar
                    size="xs"
                    on-click="$ctrl.onClick(button)"
                    is-editable="$ctrl.isEditable"
            />
        </div>

        <div ng-if="$ctrl.first" class="chat_message__addon">
            <img ng-src="{{$ctrl.image|thumb:80:80}}" alt="avatar">
        </div>
        <div ng-if="!$ctrl.first" class="chat_message__addon">
            {{::$ctrl.message.created_at|moment:'LT'}}
        </div>
        <div class="chat_message__content">
            <div ng-if="$ctrl.first" class="chat_message__header" is-uib>
                <a ng-href="{{$ctrl.ownerProfileUrl}}" class="chat_message__user" target="_blank" title="{{$ctrl.message.owner.name}}">{{$ctrl.message.owner.name}}</a>
                <div class="chat_message__place" ng-if="$ctrl.isPublicChat">via
                    <a ng-href="/{{$ctrl.place.entry_type}}/{{$ctrl.place.entry_id}}"
                       target="_blank"
                       ng-bind="::$ctrl.place.name"
                       title="{{::$ctrl.place.name}}"></a>
                </div>
                <div class="chat_message__date" moment-watch="$ctrl.message.created_at" uib-tooltip="{{::$ctrl.message.created_at|moment:'L LT'}}"></div>
            </div>

            <ty-chat-call-event type="$ctrl.message.content.event_type" ng-if="$ctrl.isCallEvent"/>

            <ty-chat-quoted-message quoted-message="$ctrl.quotedMessage" is-public-chat="$ctrl.isPublicChat" ng-if="$ctrl.quotedMessage" class="chat_message__quoted_message"/>

            <div ng-if="$ctrl.isMessage" class="chat_message__message" ng-bind-html="$ctrl.message.content|emojis|markdown|highlight:$ctrl.searchTerm"></div>

            <div class="chat_message__attachments" ng-if="$ctrl.hasAttachments" ng-switch="$ctrl.attachmentsDisplayMode">

                <ty-chat-message-attachment-gallery ng-switch-when="gallery" message="$ctrl.message" attachments="$ctrl.message.attachments" />

                <ty-chat-message-attachment
                        ng-switch-default
                        ng-repeat="attachment in $ctrl.message.attachments"
                        attachment="attachment"
                        attachments="$ctrl.message.attachments"
                        message="$ctrl.message"
                />
            </div>

            <div class="chat_message__edited_indicator" ng-if="$ctrl.message.edited_at && $ctrl.isMessage" uib-tooltip="{{$ctrl.message.edited_at|moment:'L LT'}}">(edited)</div>

            <div class="chat_message__failed" ng-if="$ctrl.message.failed">
                We couldn't send this message <br>
                <a href="#" ng-click="$ctrl.resend()">Send Again</a> |
                <a href="#" ng-click="$ctrl.cancel()">Cancel</a>
            </div>
        </div>
    </div>
`,
        bindings: {
            message: '<',
            first: '<',
            searchTerm: '<',
            isPublicChat: '<',
        },
        controller: ChatMessageComponent,
    });
})();
